import React, { useEffect, useState } from 'react'
import {
  makeStyles,
  createStyles,
  useTheme,
  Box,
  Button,
  Typography,
  Grid,
  useMediaQuery,
  Divider,
  Dialog,
  IconButton,
  DialogContent,
} from '@material-ui/core'
import AccessTimeIcon from '@material-ui/icons/AccessTime'
import getTime from 'date-fns/getTime'
import isBefore from 'date-fns/isBefore'
import parse from 'date-fns/parse'
import classnames from 'classnames'
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined'
import {
  useParams,
  // Link,
  useLocation,
  useHistory,
  useRouteMatch,
} from 'react-router-dom'
import { matchPath } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import Countdown from 'react-countdown'
import { useTranslation } from 'react-i18next'
import ENumberFormat from 'src/mobile/themes/components/ENumberFormat'
import { pay, getOrderInfo, applyRefund, cancelRefund } from 'src/store/slices/userSlice'
// import DialogButton from './dialogButton/DialogButton'
import { useCustomTranslation, useDateFnsLocale, useImageTranslation, useAddressFormat } from 'src/hooks'
import EDialog from 'src/mobile/themes/components/EDialog'
import CloseIcon from '@material-ui/icons/Close'
import GoogleMap from '../mobile/components/GoogleMap'
import MapOutlinedIcon from '@material-ui/icons/MapOutlined'
import {
  PAY_EXPIRED_TIME,
  SERVICE_PHONE_02,
  SERVICE_CHARGE_RATE,
  DATE_FORMAT,
  DATABASE_DATE_TIMEZONE_TIME_FORMAT,
  TIMEZONE,
  ORDER_STATUS,
  PACKAGE_INFO,
  MOBILE_HEADER_HEIGHT,
  SITE_MATE_DATA,
} from 'src/utils/constant'
import { encryptId, formatDialingCode, translateRegion } from 'src/utils'
import Loading from './Loading'
// import ClinicLink from 'src/components/ClinicLink'
// import TagManager from 'react-gtm-module'
// import { ReactComponent as Submit } from '../assets/icons/submitFaq.svg'
import { getUserInfo } from 'src/store/slices/authSlice'
import { ReactComponent as PendingPayment } from 'src/mobile/assets/icons/pending_payment.svg'
import { ReactComponent as Refund } from 'src/mobile/assets/icons/refunded.svg'
import { ReactComponent as FailRefund } from 'src/mobile/assets/icons/failed_refunded.svg'
import { ReactComponent as Refunding } from 'src/mobile/assets/icons/refunding.svg'
import { ReactComponent as Paid } from 'src/mobile/assets/icons/paid.svg'
import { ORDER_STATUS_HEADER } from 'src/mobile/utils/constant'
import { ReactComponent as Return } from 'src/assets/icons/Return.svg'
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined'
import DateRangeOutlinedIcon from '@material-ui/icons/DateRangeOutlined'
import { ReactComponent as DoctorIcon } from 'src/mobile/assets/icons/doctor2.svg'
import { buttonClick } from 'src/utils/trackingCode'
// import EDrawer from 'src/mobile/themes/components/EDrawer'

const useStyles = makeStyles((theme) =>
  createStyles({
    content: {
      flexGrow: 1,
      padding: 0,
      maxWidth: theme.spacing(150),
      paddingTop: theme.spacing(4),
      fontSize: theme.spacing(2),
    },
    back: {
      cursor: 'pointer',
    },
    sidebarTank: {
      width: theme.spacing(40),
      flexShrink: 0,
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingTop: theme.spacing(4),
    },
    closeButton2: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
    },
    sidebarContent: {
      borderLeft: '1px solid #E5E7EB',
      paddingRight: '106px',
      paddingLeft: theme.spacing(5),
      [theme.breakpoints.down('md')]: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
      },
      [theme.breakpoints.down('xs')]: {
        paddingTop: theme.spacing(MOBILE_HEADER_HEIGHT),
        paddingLeft: 0,
        paddingRight: 0,
      },
    },
    userRoutesContent: {
      display: 'flex',
      margin: theme.spacing(0, 5.5),
      [theme.breakpoints.down('md')]: {
        margin: theme.spacing(0, 0),
        paddingTop: theme.spacing(MOBILE_HEADER_HEIGHT + 2),
      },
      [theme.breakpoints.down('xs')]: {
        margin: theme.spacing(0, 2),
        paddingTop: theme.spacing(MOBILE_HEADER_HEIGHT + 12),
      },
      marginTop: theme.spacing(10),
    },
    test: {
      lineHeight: '2.5',
      fontSize: 16,
      fontWeight: 400,
      [theme.breakpoints.down('xs')]: {
        fontSize: 14,
        fontWeight: 500,
      },
    },
    heading: {
      fontSize: 16,
      fontWeight: 400,
      [theme.breakpoints.down('xs')]: {
        fontSize: 14,
      },
    },
    infoHeader: {},
    infoHeaderContent: {
      display: 'flex',
      alignItems: 'center',
    },
    infoHeaderCover: {
      display: 'block',
      height: 50,
      flexShrink: 0,
      marginRight: theme.spacing(2),
    },
    infoContent: {},
    dialogContent2: {
      paddingBottom: theme.spacing(4),
    },
    btn: {
      margin: theme.spacing(0, 2),
      width: theme.spacing(20),
      height: 60,
      fontSize: 18,
      fontWeight: 600,
    },
    refundBtn: {
      color: '#fff',
      background: '#D6334D',
      fontSize: 16,
    },
    divider: {
      backgroundColor: theme.palette.grey[300],
      height: 1,
    },
    tipsLink: {
      color: theme.palette.primary.main,
      textDecoration: 'underline',
      fontWeight: 700,
    },
    matchOrderInfo: {
      maxWidth: theme.spacing(120),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.text.primary,
    },
    dialogContent: {
      padding: 0,
      minWidth: 600,
      minHeight: 480,
    },
    dialogTitle: {
      backgroundColor: '#fff',
      color: theme.palette.text.primary,
      borderBottom: `1px solid ${theme.palette.grey[400]}`,
    },
    dialogTitle2: {
      backgroundColor: '#fff',
      color: theme.palette.text.primary,
    },
    formLabel: {
      display: 'flex',
      color: theme.palette.text.primary,
      fontSize: 18,
      fontWeight: 500,
      lineHeight: '26px',
    },
    radio: {
      display: 'flex',
      flexDirection: 'column',
      marginLeft: theme.spacing(3),
      color: theme.palette.text.primary,
    },
    accordionDetails: {
      display: 'flex',
      alignItems: 'center',
      padding: 0,
      justifyContent: 'space-between',
    },
    matters: {
      paddingLeft: theme.spacing(2),
      lineHeight: '2.5',
    },
  }),
)

const OrderInfo = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { t, i18n } = useTranslation()
  const [tImage] = useImageTranslation()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const matches = useMediaQuery(theme.breakpoints.down('xs'))
  const history = useHistory()
  const { pathname } = useLocation()
  const { formatDate } = useDateFnsLocale()
  const { orderInfo, orderInfoStatus } = useSelector((state) => state.user)
  const { userInfo } = useSelector((state) => state.auth)
  const { orderNumber } = useParams()
  const isPayingSuccessPage = useRouteMatch(`${i18n.language}/add-order/success/:orderNumber`)
  const setOrderInfo = async () => await dispatch(getOrderInfo({ orderNumber: orderNumber })).unwrap()
  const [tB] = useCustomTranslation()
  const [drawerOpen, setEDrawerOpen] = useState(false)
  const { addressFormat } = useAddressFormat()

  useEffect(() => {
    setOrderInfo()
  }, [])

  // useEffect(() => {
  //   if (isPayingSuccessPage && orderInfo?.payStatus === ORDER_STATUS.PAID) {
  //     TagManager.dataLayer({
  //       dataLayer: {
  //         ecommerce: null,
  //       },
  //     })
  //     TagManager.dataLayer({
  //       dataLayer: {
  //         event: 'purchase',
  //         ecommerce: {
  //           purchase: {
  //             actionField: {
  //               id: `${orderInfo.orderNumber || ''}`,
  //               revenue: `${orderInfo.price || ''}`,
  //               tax: '0',
  //               shipping: '0',
  //               coupon: orderInfo.promotionCode || '',
  //             },
  //             products: [
  //               {
  //                 name: orderInfo.doctorName || '',
  //                 id: `${orderInfo.doctorId || ''}`,
  //                 price: `${orderInfo.price || ''}`,
  //                 brand: orderInfo.testCenterName || '',
  //                 category: orderInfo.doctorTitle || '',
  //                 variant: orderInfo.appointmentTime || '',
  //                 dimension1: orderInfo.appointmentDate || '',
  //                 quantity: 1,
  //               },
  //             ],
  //           },
  //         },
  //       },
  //     })
  //   }
  // }, [orderInfo?.payStatus])
  useEffect(() => {
    dispatch(getUserInfo())
  }, [])
  // const handleCancel = async () => {
  //   await dispatch(cancelOrder({ orderNumber: orderNumber })).unwrap()
  //   TagManager.dataLayer({
  //     dataLayer: {
  //       ecommerce: null,
  //     },
  //   })
  //   TagManager.dataLayer({
  //     dataLayer: {
  //       event: 'removeFromCart',
  //       ecommerce: {
  //         currencyCode: orderInfo.currency,
  //         remove: {
  //           products: [
  //             {
  //               name: orderInfo.doctorName || '',
  //               id: `${orderInfo.doctorId || ''}`,
  //               price: `${orderInfo.price || ''}`,
  //               brand: orderInfo.testCenterName || '',
  //               category: orderInfo.doctorTitle || '',
  //               variant: orderInfo.appointmentTime || '',
  //               dimension1: orderInfo.appointmentDate || '',
  //               quantity: 1,
  //             },
  //           ],
  //         },
  //       },
  //     },
  //   })
  //   setOrderInfo()
  // }

  const handlePay = async () => {
    if (orderInfo.currency !== 'HKD') {
      // TagManager.dataLayer({
      //   dataLayer: {
      //     ecommerce: null,
      //   },
      // })
      // TagManager.dataLayer({
      //   dataLayer: {
      //     event: 'checkout',
      //     ecommerce: {
      //       checkout: {
      //         actionField: { step: 2 },
      //         products: [
      //           {
      //             name: orderInfo.doctorName || '',
      //             id: `${orderInfo.doctorId || ''}`,
      //             price: `${orderInfo.price || ''}`,
      //             brand: orderInfo.testCenterName || '',
      //             category: orderInfo.doctorTitle || '',
      //             variant: orderInfo.appointmentTime || '',
      //             dimension1: orderInfo.appointmentDate || '',
      //             quantity: 1,
      //           },
      //         ],
      //       },
      //     },
      //   },
      // })
      await dispatch(pay({ orderNumber: orderNumber }))
    } else {
      history.push(`/${i18n.language}/add-order/paying`, {
        price: orderInfo.price,
        currency: orderInfo.currency,
        orderNumber: orderNumber,
        packages: orderInfo.package,
        from: 'orderInfo',
      })
    }
  }

  const handleRefund = async () => {
    buttonClick(
      'EH_MyAccount_Refund_ConfirmRefund',
      'EH_MyAccount_Refund_ConfirmRefund',
    )
    await dispatch(applyRefund({ orderNumber: orderNumber })).unwrap()
    // setDialogOpen(true)
    setOrderInfo()
    // setRefundFaq(true)
  }

  const handleCancelRefund = async () => {
    await dispatch(cancelRefund({ orderNumber: orderNumber })).unwrap()
    setOrderInfo()
    setEDrawerOpen(false)
  }

  // const OrderInfoBox = ({ status, type }) => (
  //   <Box fontSize="body2.fontSize">
  //     {t('glossary.order_id')}: {orderInfo.orderNumber} <br />
  //     {t('glossary.appointment', { field: '$t(glossary.clinic)' })}:{' '}
  //     <ClinicLink id={orderInfo.testCenterId}>{orderInfo?.[tB('testCenterName')]}</ClinicLink> <br />
  //     {t('glossary.appointment', { field: '$t(glossary.doctor)' })}: {orderInfo?.[tB('doctorName')]}
  //     {orderInfo?.[tB('doctorTitle')] + t('glossary.doctor')}
  //     <br />
  //     {t('glossary.appointment_person')}: {orderInfo.userName} <br />
  //     {t('glossary.appointment_time')}: {formatDate(new Date(orderInfo.appointmentDate))}
  //     {orderInfo.appointmentTime} <br />
  //     {t('glossary.clinic') + t('form.address')}:{' '}
  //     {t(translateRegion(orderInfo?.area)) + orderInfo?.[tB('testCenterAddress')]}
  //     <br />
  //     {t('form.program')}: {t(PACKAGE_INFO[orderInfo.package].title)}
  //     <br />
  //     {status !== ORDER_STATUS.PENDING_PAYMENT ? (
  //       <>
  //         {t('glossary.pay_amount')}:{' '}
  //         <ENumberFormat value={orderInfo.payPrice} currency={orderInfo.currency} />
  //         <Box color="error.main">
  //           {t('glossary.refund_amount')}:{' '}
  //           <ENumberFormat
  //             value={
  //               orderInfo.payMethod === 'Atome'
  //                 ? orderInfo.payPrice
  //                 : orderInfo.payPrice *
  //                   (1 - (orderInfo.refundOrigin || status === ORDER_STATUS.PAID ? SERVICE_CHARGE_RATE : 0))
  //             }
  //             currency={orderInfo.currency}
  //           />
  //         </Box>
  //       </>
  //     ) : (
  //       type === 'pay' && (
  //         <>
  //           {t('glossary.pay_amount')}:{' '}
  //           <ENumberFormat value={orderInfo.price} currency={orderInfo.currency} />
  //         </>
  //       )
  //     )}
  //   </Box>
  // )
  const statusMark = (status) => {
    return (
      <Box
        alignItems="center"
        display="flex"
        fontSize={16}
        color={
          status === ORDER_STATUS.PENDING_REFUND || status === ORDER_STATUS.APPROVAL_SUCCEED
            ? 'secondary.main'
            : status === ORDER_STATUS.PENDING_PAYMENT
            ? '#CC9809'
            : 'grey.800'
        }
      >
        {status === ORDER_STATUS.PENDING_REFUND && <Box className={classes.dot} />}
        {t(ORDER_STATUS_HEADER?.[status]?.label)}
      </Box>
    )
  }
  const fixedButtonWrapper = (status) => {
    return (
      <>
        {status === ORDER_STATUS.PENDING_PAYMENT && (
          <Box mb={4} display="flex" justifyContent="flex-end">
            <Button
              onClick={handlePay}
              variant="contained"
              style={{
                background: 'rgb(242, 81, 45)',
                color: '#ffff',
                height: 60,
                width: 160,
                fontSize: 18,
                fontWeight: 600,
              }}
            >
              {t('glossary.go_to_pay')}
            </Button>
            {/* <DialogButton
              className={classes.btn}
              name={t('glossary.go_to_pay')}
              variant="contained"
              size="small"
              color="secondary"
              onConfirm={handlePay}
              loading
            >
              <OrderInfoBox status={orderInfo.payStatus} type="pay" />
            </DialogButton> */}
          </Box>
        )}
        {status === ORDER_STATUS.PAID && !isPayingSuccessPage && (
          <Box mb={4} display="flex" justifyContent="flex-end">
            <EDialog
              loading
              updateBooking={true}
              title={t('common.update_booking')}
              trigger={
                <Button
                  className={classes.btn}
                  variant="outlined"
                  style={{ height: 60, fontSize: 18, fontWeight: 600, width: 160 }}
                >
                  {t('common.update_booking')}
                </Button>
              }
              onConfirm={() => {
                window.location.href =
                  i18n.language === 'zh-HK'
                    ? SITE_MATE_DATA.WHATSAPP_UPDATE_HK
                    : i18n.language === 'en'
                    ? SITE_MATE_DATA.WHATSAPP_UPDATE_EN
                    : SITE_MATE_DATA.WHATSAPP_UPDATE_CN
              }}
            >
              <Box my={2}> {t('common.update_booking_tips', { field: SERVICE_PHONE_02 })}</Box>
            </EDialog>

            {isBefore(new Date(), parse(orderInfo.appointmentDate, DATE_FORMAT, new Date())) && (
              <>
                {' '}
                <Button
                  variant="contained"
                  onClick={() => setEDrawerOpen(true)}
                  style={{
                    fontSize: 18,
                    fontWeight: 600,
                    background: '#D6334D',
                    color: '#ffff',
                    height: 60,
                    width: 160,
                  }}
                >
                  {t('glossary.apply_refund')}
                </Button>{' '}
                <Dialog onClose={() => setEDrawerOpen(false)} open={drawerOpen}>
                  <Box mb={2}>
                    <Box py={2} fontSize={20} fontWeight={600} textAlign="center">
                      {t('glossary.apply_refund')}
                    </Box>
                    <IconButton
                      className={classes.closeButton2}
                      aria-label="close"
                      onClick={() => {
                        setEDrawerOpen(false)
                      }}
                      color="primary"
                    >
                      <CloseIcon />
                    </IconButton>
                    <Divider />
                  </Box>
                  <DialogContent className={classes.dialogContent2}>
                    <Box color="grey.900" my={2} lineHeight={1.5}>
                      {t('common.refund_tips')}
                    </Box>
                    <Divider />
                    <Box fontSize={16} fontWeight={600} lineHeight={2}>
                      {t('glossary.pay_amount')}
                    </Box>{' '}
                    <ENumberFormat
                      color="grey.400"
                      type="simple"
                      value={orderInfo?.payPrice}
                      currency={orderInfo?.currency}
                    />
                    <Box fontSize={16} fontWeight={600} lineHeight={2} mt={1.5}>
                      {t('glossary.refund_amount')}
                    </Box>
                    <ENumberFormat
                      type="simple"
                      color="grey.400"
                      value={
                        orderInfo.payMethod === 'Atome'
                          ? orderInfo.payPrice
                          : orderInfo?.payPrice *
                            (1 -
                              (orderInfo?.refundOrigin || orderInfo.payStatus === 1
                                ? SERVICE_CHARGE_RATE
                                : 0))
                      }
                      currency={orderInfo?.currency}
                    />
                    <Divider style={{ marginTop: '16px' }} />
                    <Box display="flex" my={1} justifyContent="space-between">
                      <Box className={classes.column} flexShrink="0">
                        <Typography className={classes.heading}>{t('glossary.order_id')}</Typography>
                      </Box>
                      <Box>
                        <Typography className={classes.secondaryHeading}>{orderInfo?.orderNumber}</Typography>
                      </Box>
                    </Box>
                    <Divider />
                    <Box mt={3}>
                      <Box fontSize={18} fontWeight={700}>
                        {t(PACKAGE_INFO[orderInfo?.package].title)}
                      </Box>
                    </Box>
                    <Box display="flex" alignItems="center" my={3}>
                      <LocationOnOutlinedIcon variant="outline" style={{ fontSize: 16, marginRight: 4 }} />
                      <Box component="span" fontSize={16} fontWeight={700}>
                        {orderInfo?.[tB('testCenterName')]}
                      </Box>
                    </Box>{' '}
                    <Box fontSize={14} ml={2.5} mb={3} color="#4B5563">
                      {orderInfo?.[tB('testCenterAddress')]}
                    </Box>
                    <Divider />
                    <Box display="flex" alignItems="center" my={3} justifyContent="space-between">
                      <Box display="flex" alignItems="center" fontWeight={600} fontSize={14}>
                        <DateRangeOutlinedIcon variant="outline" style={{ marginRight: 4 }} />
                        {t('common.booking_date')}
                      </Box>
                      <Box component="span" fontSize={14}>
                        {formatDate(new Date(orderInfo?.appointmentDate))}
                      </Box>
                    </Box>
                    <Divider />
                    <Box
                      component="span"
                      display="flex"
                      alignItems="center"
                      my={3}
                      justifyContent="space-between"
                    >
                      <Box display="flex" alignItems="center" fontWeight={600} fontSize={14}>
                        <AccessTimeIcon variant="outline" style={{ marginRight: 4 }} />
                        {t('glossary.appointment_time')}
                      </Box>
                      <Box fontSize={14}> {orderInfo?.appointmentTime}</Box>
                    </Box>
                    <Divider />
                    <Box display="flex" alignItems="center" my={3} justifyContent="space-between">
                      <Box display="flex" alignItems="center" fontWeight={600} fontSize={14}>
                        <DoctorIcon variant="outline" style={{ marginRight: 4 }} />
                        {t('glossary.doctor')}
                      </Box>
                      <Box component="span" fontSize={14} fontWeight={700}>
                        {orderInfo?.[tB('doctorName')] || ''}
                      </Box>
                    </Box>
                    <Divider />
                    <Box display="flex" alignItems="center" my={3} justifyContent="space-between" pb={1}>
                      <Box display="flex" alignItems="center" fontWeight={600} fontSize={14}>
                        <PersonOutlineOutlinedIcon variant="outline" style={{ marginRight: 4 }} />
                        {t('common.tester')}
                      </Box>
                      <Box component="span" fontSize={14}>
                        {orderInfo?.userName}
                      </Box>{' '}
                    </Box>{' '}
                    <Divider />
                    <Box my={3}>
                      <EDialog
                        loading
                        noAction={true}
                        title={t('common.refund_rules')}
                        trigger={
                          <Box style={{ textDecorationLine: 'underline' }} fontSize={16}>
                            {t('common.refund_notice')}
                          </Box>
                        }
                      >
                        <Box my={1} lineHeight={1.5} fontSize={16}>
                          {' '}
                          {t('common.refund_detail_rules')}
                        </Box>
                      </EDialog>
                    </Box>
                  </DialogContent>
                  <Divider />
                  <Box display="flex" justifyContent="space-evenly" my={2}>
                    <Button
                      fullWidth
                      onClick={() => setEDrawerOpen(false)}
                      variant="outlined"
                      style={{ width: 183, height: 60, fontSize: 18, fontWeight: 600 }}
                    >
                      {t('common.cancel')}
                    </Button>{' '}
                    <Button
                      onClick={handleRefund}
                      style={{
                        background: '#D6334D',
                        color: '#fff',
                        width: 183,
                        height: 60,
                        fontSize: 18,
                        fontWeight: 600,
                      }}
                      fullWidth
                    >
                      {t('common.confirm_refund')}
                    </Button>
                  </Box>
                </Dialog>
              </>

              // <DialogButton
              //   className={[classes.btn, classes.refundBtn]}
              //   name={t('glossary.apply_refund')}
              //   onConfirm={handleRefund}
              //   size="small"
              //   type="refund"
              //   loading
              // >
              //   <Typography component="div">
              //     <Box color="grey.900" my={2} lineHeight={1.5}>
              //       {t('common.refund_tips')}
              //     </Box>
              //     <Divider />
              //     <Box fontSize={16} fontWeight={600} lineHeight={2}>
              //       {t('glossary.pay_amount')}
              //     </Box>{' '}
              //     <ENumberFormat
              //       color="grey.400"
              //       type="simple"
              //       value={orderInfo?.payPrice}
              //       currency={orderInfo?.currency}
              //     />
              //     <Box fontSize={16} fontWeight={600} lineHeight={2} mt={1.5}>
              //       {t('glossary.refund_amount')}
              //     </Box>
              //     <ENumberFormat
              //       type="simple"
              //       color="grey.400"
              //       value={
              //         orderInfo.payMethod === 'Atome'
              //           ? orderInfo.payPrice
              //           : orderInfo?.payPrice *
              //             (1 -
              //               (orderInfo?.refundOrigin || orderInfo.payStatus === 1 ? SERVICE_CHARGE_RATE : 0))
              //       }
              //       currency={orderInfo?.currency}
              //     />
              //     <Divider style={{ marginTop: '16px' }} />
              //     <Box display="flex" my={1} justifyContent="space-between">
              //       <Box className={classes.column} flexShrink="0">
              //         <Typography className={classes.heading}>{t('glossary.order_id')}</Typography>
              //       </Box>
              //       <Box>
              //         <Typography className={classes.secondaryHeading}>{orderInfo?.orderNumber}</Typography>
              //       </Box>
              //     </Box>
              //     <Divider />
              //     <Box mt={2}>
              //       <Box fontSize={18} fontWeight={700}>
              //         {t(PACKAGE_INFO[orderInfo?.package].title)}
              //       </Box>
              //     </Box>
              //     <Box display="flex" alignItems="center" my={1}>
              //       <LocationOnOutlinedIcon variant="outline" style={{ fontSize: 16, marginRight: 4 }} />
              //       <Box component="span" fontSize={16} fontWeight={700}>
              //         {orderInfo?.[tB('testCenterName')]}
              //       </Box>
              //     </Box>{' '}
              //     <Box fontSize={14} ml={2.5} mb={2} color="#4B5563">
              //       {orderInfo?.testCenterAddress}
              //     </Box>
              //     <Divider />
              //     <Box display="flex" alignItems="center" my={2} justifyContent="space-between">
              //       <Box display="flex" alignItems="center" fontWeight={600}>
              //         <DateRangeOutlinedIcon variant="outline" style={{ fontSize: 16, marginRight: 4 }} />
              //         {t('common.booking_date')}
              //       </Box>
              //       <Box component="span" fontSize={14}>
              //         {formatDate(new Date(orderInfo?.appointmentDate))}
              //       </Box>
              //     </Box>
              //     <Divider />
              //     <Box
              //       component="span"
              //       display="flex"
              //       alignItems="center"
              //       my={2}
              //       justifyContent="space-between"
              //     >
              //       <Box display="flex" alignItems="center" fontWeight={600}>
              //         <AccessTimeIcon variant="outline" style={{ fontSize: 16, marginRight: 4 }} />
              //         {t('glossary.appointment_time')}
              //       </Box>
              //       <Box> {orderInfo?.appointmentTime}</Box>
              //     </Box>
              //     <Divider />
              //     <Box display="flex" alignItems="center" my={2} justifyContent="space-between">
              //       <Box display="flex" alignItems="center" fontWeight={600}>
              //         <DoctorIcon variant="outline" style={{ fontSize: 16, marginRight: 4, width: 20 }} />

              //         {t('glossary.doctor')}
              //       </Box>
              //       <Box component="span" fontSize={14} fontWeight={700}>
              //         {orderInfo?.[tB('doctorName')] || ''}
              //       </Box>
              //     </Box>
              //     <Divider />
              //     <Box display="flex" alignItems="center" my={2} justifyContent="space-between" pb={1}>
              //       <Box display="flex" alignItems="center" fontWeight={600}>
              //         <PersonOutlineOutlinedIcon variant="outline" style={{ fontSize: 16, marginRight: 4 }} />
              //         {t('common.tester')}
              //       </Box>
              //       <Box component="span" fontSize={14}>
              //         {orderInfo?.userName}
              //       </Box>{' '}
              //     </Box>{' '}
              //     <EDialog
              //       loading
              //       noAction={true}
              //       title={t('common.refund_rules')}
              //       trigger={
              //         <Box mb={2} style={{ textDecorationLine: 'underline' }}>
              //           {t('common.refund_notice')}
              //         </Box>
              //       }
              //     >
              //       <Box my={1} lineHeight={1.5} fontSize={16}>
              //         {' '}
              //         {t('common.refund_detail_rules')}
              //       </Box>
              //     </EDialog>
              //   </Typography>
              // </DialogButton>
            )}
          </Box>
        )}
        {(status === ORDER_STATUS.PENDING_REFUND || status === ORDER_STATUS.APPROVAL_SUCCEED) && (
          <Box mb={4} display="flex" justifyContent="flex-end">
            <Box ml="auto">
              <EDialog
                loading
                title={t('are_you_sure.common', { action: '$t(glossary.cancel_refund)' })}
                trigger={
                  <Button variant="contained" color="secondary" className={classes.btn}>
                    {t('glossary.cancel_refund')}
                  </Button>
                }
                onConfirm={handleCancelRefund}
              />
            </Box>
          </Box>
        )}
      </>
    )
  }
  const sideBarContent = (status) => {
    return (
      <>
        {status === ORDER_STATUS.PENDING_PAYMENT && (
          <Box mt={3}>
            <Box fontSize={isMobile ? 18 : 23} fontWeight={600} color="#111827">
              {t('common.still_not_finish')}
            </Box>
            <Box mt={2}>
              <Divider className={classes.divider} />
            </Box>
            <Countdown
              date={
                getTime(
                  parse(orderInfo.createTime + TIMEZONE, DATABASE_DATE_TIMEZONE_TIME_FORMAT, new Date()),
                ) + PAY_EXPIRED_TIME
              }
              onComplete={setOrderInfo}
              autoStart
              renderer={({ hours, minutes, seconds, completed }) => {
                if (completed) {
                  return (
                    <Box display="flex" alignItems="center" mb={3} fontSize={14} color="#111827">
                      {t('tips.order_time_out')}
                    </Box>
                  )
                } else {
                  // Render a countdown
                  return (
                    <Box alignItems="center" my={2} fontSize={14} color="#111827" lineHeight="150%">
                      {/* {t('tips.time_out_close_order_automatically', {
                        hour: `0${hours}`.slice(-2),
                        minute: `0${minutes}`.slice(-2),
                        second: `0${seconds}`.slice(-2),
                      })} */}
                      {/* "{{ hour }}小时{{ minute }}分{{ second }}秒 */}
                      {t('tips.time_out_close_order_automatically')}
                      <br />
                      <Box fontWeight={600}>
                        {`0${hours}`.slice(-2)}:{minutes}:{seconds}
                      </Box>
                    </Box>
                  )
                }
              }}
            />
          </Box>
        )}
        {/* {status === ORDER_STATUS.PAID && !isPayingSuccessPage && (
          <Box mt={3}>
            <Box fontSize={18} fontWeight={600}>
              {t('common.medical_report')}
            </Box>
            <Box mt={2}>
              <Divider className={classes.divider} />
            </Box>
          </Box>
        )} */}
        {(status === ORDER_STATUS.PENDING_REFUND ||
          status === ORDER_STATUS.APPROVAL_SUCCEED ||
          status === ORDER_STATUS.REFUNDED ||
          status === ORDER_STATUS.APPROVAL_FAILED ||
          status === ORDER_STATUS.REFUND_FAILED) && (
          <Box mt={3}>
            <Box fontSize={18} fontWeight={600}>
              {t('options.order_list_types.3')}
            </Box>
            <Box my={2}>
              <Divider className={classes.divider} />
            </Box>
            <Box fontSize={16} color="#9CA3AF" display="flex" justifyContent="space-between">
              <Box> {t('common.apple_refund_time')}</Box>
              <Box>{orderInfo?.refundApplyTime?.slice(0, 11)}</Box>
            </Box>
            <Box mt={2} lineHeight={1.5} fontSize={16} color="#111827">
              {status === ORDER_STATUS.REFUNDED && (
                <Box>{t('tip.refunded', { field: SERVICE_PHONE_02 })}</Box>
              )}
              {(status === ORDER_STATUS.REFUND_FAILED || status === ORDER_STATUS.APPROVAL_FAILED) && (
                <Box>{t('tips.refund_failed')}</Box>
              )}

              {status === ORDER_STATUS.PENDING_REFUND && <Box>{t('tips.refund_tips_list.1')}</Box>}
            </Box>
          </Box>
        )}
      </>
    )
  }

  return orderInfo && orderInfoStatus !== 'pending' ? (
    <Box className={classes.userRoutesContent}>
      <Box className={classes.sidebarTank}>
        <Box
          mt={1}
          color="primary.main"
          fontSize={14}
          fontWeight={700}
          border="1px solid #E5E7EB"
          display="flex"
          width={272}
          height={56}
          borderRadius={30}
          alignItems="center"
          justifyContent="center"
          className={classes.back}
          onClick={() => history.push(`/${i18n.language}/profile/order`)}
        >
          <Return />
          {t('common.back')}
        </Box>
        {sideBarContent(orderInfo.payStatus)}
      </Box>
      <main className={classnames(classes.content, classes.sidebarContent)}>
        <Box
          className={classnames({
            [classes.matchOrderInfo]: matchPath(pathname, {
              path: '/profile/order/:orderNumber',
              exact: true,
            }),
          })}
        >
          {/* header */}
          <Box display="flex" justifyContent="space-between" my={1}>
            <Box fontSize={18} fontWeight={600}>
              {t('glossary.appointment_detail')}
            </Box>
            {!isPayingSuccessPage && (
              <Box
                pb={1.5}
                justifyContent="space-between"
                alignItems="center"
                display="flex"
                color="grey.900"
              >
                <Box display="flex" alignItems="center">
                  <Box mr={1}> {statusMark(orderInfo.payStatus)}</Box>
                  {orderInfo?.payStatus === ORDER_STATUS.PAID && <Paid />}
                  {orderInfo?.payStatus === ORDER_STATUS.PENDING_PAYMENT && <PendingPayment />}

                  {orderInfo?.payStatus === ORDER_STATUS.REFUNDED && <Refund />}
                  {(orderInfo?.payStatus === ORDER_STATUS.REFUND_FAILED ||
                    orderInfo?.payStatus === ORDER_STATUS.APPROVAL_FAILED) && <FailRefund />}
                  {(orderInfo.payStatus === ORDER_STATUS.PENDING_REFUND ||
                    orderInfo.payStatus === ORDER_STATUS.APPROVAL_SUCCEED) && <Refunding />}
                </Box>
              </Box>
            )}
          </Box>

          <Divider className={classes.divider} />

          {/* body */}

          {/* 订单详情 */}
          <>
            <Box display="flex" my={1} justifyContent="space-between">
              <Box className={classes.column} flexShrink="0">
                <Typography className={classes.heading}>{t('glossary.order_id')}</Typography>
              </Box>
              <Box>
                <Typography className={classes.secondaryHeading}>{orderInfo?.orderNumber}</Typography>
              </Box>
            </Box>
            <Box display="flex">
              <img src={tImage('thumb', 'jpg')} alt="product_thumb" width={120} height={120} />

              <Box ml={2}>
                <Box fontSize={18} fontWeight={700}>
                  {t(PACKAGE_INFO[orderInfo?.package].title)}
                </Box>
                <Box mt={1}>
                  <ENumberFormat
                    color="secondary.main"
                    value={Number(orderInfo?.price)}
                    currency={orderInfo?.currency}
                  />
                </Box>
              </Box>
            </Box>
            <Box display="flex" alignItems="center" my={1} justifyContent="space-between">
              <Box display="flex" alignItems="center" fontSize={16} fontWeight={700}>
                <LocationOnOutlinedIcon variant="outline" style={{ marginRight: 4 }} />
                {orderInfo?.[tB('testCenterName')]}
              </Box>
              <Box component="span" display="flex" alignItems="center">
                <Box flexShrink={0}>
                  <GoogleMap
                    lng={orderInfo?.lng}
                    lat={orderInfo?.lat}
                    name={orderInfo[tB('testCenterName')]}
                    address={addressFormat(
                      orderInfo[tB('testCenterAddress')],
                      t(translateRegion(orderInfo?.area)),
                    )}
                  >
                    <Box display="flex">
                      <MapOutlinedIcon style={{ color: '#24252d' }} />
                      <span
                        style={{
                          fontSize: 16,
                          lineHeight: 1.5,
                          textDecoration: 'underline',
                          color: '#24252d',
                          cursor: 'pointer',
                        }}
                      >
                        {t('glossary.map')}
                      </span>
                    </Box>
                  </GoogleMap>
                </Box>
              </Box>
            </Box>{' '}
            <Box fontSize={14} ml={2.5} mb={2} color="#4B5563">
              {orderInfo?.[tB('testCenterAddress')]}
            </Box>
            <Divider className={classes.divider} />
            <Box display="flex" alignItems="center" my={3} justifyContent="space-between">
              <Box display="flex" alignItems="center" fontWeight={600}>
                <DateRangeOutlinedIcon variant="outline" style={{ marginRight: 4 }} />
                {t('common.booking_date')}
              </Box>
              <Box component="span" fontSize={matches ? 14 : 16}>
                {formatDate(new Date(orderInfo?.appointmentDate))}
              </Box>
            </Box>
            <Divider className={classes.divider} />
            <Box component="span" display="flex" alignItems="center" my={3} justifyContent="space-between">
              <Box display="flex" alignItems="center" fontWeight={600}>
                <AccessTimeIcon variant="outline" style={{ marginRight: 4 }} />
                {t('glossary.appointment_time')}
              </Box>
              <Box fontSize={matches ? 14 : 16}> {orderInfo?.appointmentTime}</Box>
            </Box>
            <Divider className={classes.divider} />
            <Box display="flex" alignItems="center" my={3} justifyContent="space-between">
              <Box display="flex" alignItems="center" fontWeight={600}>
                <DoctorIcon variant="outline" style={{ marginRight: 4 }} />
                {t('glossary.doctor')}
              </Box>
              <Box component="span" fontSize={matches ? 14 : 16} fontWeight={700}>
                {orderInfo?.[tB('doctorName')] || ''}
              </Box>
            </Box>
            <Divider className={classes.divider} />
          </>

          {/* 付款 */}
          <>
            <Box my={3}>
              {Number(orderInfo?.price - orderInfo?.payPrice) > 0 &&
                orderInfo?.payStatus !== ORDER_STATUS.PENDING_PAYMENT &&
                orderInfo?.payStatus !== ORDER_STATUS.CANCELLED && (
                  <Box className={classes.accordionDetails} mb={1}>
                    <Box className={classes.column} color="#4B5563">
                      <Typography>{t('common.promotion_price')}</Typography>
                    </Box>
                    <Box>
                      <Typography>
                        -
                        <ENumberFormat
                          fontSize={matches ? 14 : 16}
                          value={Number(orderInfo?.price - orderInfo?.payPrice)}
                          currency={orderInfo?.currency}
                        />
                      </Typography>
                    </Box>
                  </Box>
                )}
              <Box className={classes.accordionDetails}>
                <Box className={classes.column} color="#111827">
                  <Typography className={classes.heading}>{t('common.add_summary')}</Typography>
                </Box>
                <Box>
                  <Typography className={classes.secondaryHeading}>
                    <ENumberFormat
                      value={Number(Number(orderInfo?.payPrice ? orderInfo?.payPrice : orderInfo?.price))}
                      currency={orderInfo?.currency}
                      color="#111827"
                    />
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Divider className={classes.divider} />
            {orderInfo?.payPrice && (
              <Box>
                <Box className={classes.accordionDetails} my={3}>
                  <Box className={classes.column} color="#4B5563">
                    <Typography className={classes.heading}>{t('payMents.payMethods.0')}</Typography>
                  </Box>
                  <Box>{orderInfo?.payMode || (orderInfo?.payMethod ? 'Atome' : '')}</Box>
                </Box>
                <Box className={classes.accordionDetails} mb={3}>
                  <Box className={classes.column} color="#4B5563">
                    <Typography className={classes.heading}>{t('common.pay_date')}</Typography>
                  </Box>
                  <Box>{orderInfo?.payTime}</Box>
                </Box>
                <Box my={2}>
                  <Divider className={classes.divider} />
                </Box>
              </Box>
            )}
          </>

          {/* 联络及测试者资料 */}
          <Box fontSize={16} fontWeight={600} color="secondary.main" mt={3}>
            {t('common.test_and_contact')}
          </Box>
          <Grid container spacing={1}>
            <Grid item xs={matches ? 6 : 7}>
              {userInfo && (
                <Box textAlign="left">
                  <Typography variant="body2" color="initial" component="div" className={classes.test}>
                    <Box> {t('form.name')}</Box>
                    <Box> {t('form.id_number')}</Box>
                    <Box> {t('form.birthday')}</Box>
                    <Box> {t('form.mobile_phone')}</Box>
                    <Box> {t('form.email')}</Box>
                  </Typography>
                </Box>
              )}
            </Grid>
            <Grid item xs={matches ? 6 : 5}>
              {userInfo && (
                <Box textAlign="right">
                  <Typography variant="body2" color="initial" component="div" className={classes.test}>
                    {userInfo.nameEn || userInfo.nameCn}
                    <br />
                    {encryptId(userInfo.identifyId, userInfo.identifyType)}
                    <br />
                    {userInfo.birthday}
                    <br />
                    {formatDialingCode(userInfo.dialingCode) + userInfo.phone}
                    <br />
                    {userInfo.email}
                  </Typography>
                </Box>
              )}
            </Grid>
          </Grid>
          <Box my={3}>
            <Divider className={classes.divider} />
          </Box>

          {/* 注意事项  */}
          <Typography component="div">
            <Box mt={4} fontSize="body1.fontSize" color="secondary.main" fontWeight="bold">
              {t('tips.main_tips')}:
            </Box>
            <Box fontSize="body2.fontSize">
              {orderInfo?.package > 2 ? (
                <ul className={classes.matters}>
                  <li> {t('tips.appointment_tips_list.10')}</li>
                  <li>{t('tips.appointment_tips_list.3')}</li>
                  <li> {t('tips.appointment_tips_list.11')}</li>
                  <li> {t('tips.appointment_tips_list.12')}</li>
                  <li> {t('tips.appointment_tips_list.8')}</li>
                  <li> {t('tips.appointment_tips_list.9', { phone: SERVICE_PHONE_02 })}</li>
                  <li> {t('tips.appointment_tips_list.5', { phone: SERVICE_PHONE_02 })}</li>
                </ul>
              ) : (
                <ul className={classes.matters}>
                  <li> {t('tips.appointment_tips_list.7')}</li>
                  <li>{t('tips.appointment_tips_list.3')}</li>
                  <li>{t('tips.appointment_tips_list.8')}</li>
                  <li>{t('tips.appointment_tips_list.9', { phone: SERVICE_PHONE_02 })}</li>
                  <li>{t('tips.appointment_tips_list.5', { phone: SERVICE_PHONE_02 })}</li>
                </ul>
              )}
            </Box>
          </Typography>

          {!(
            orderInfo?.payStatus === ORDER_STATUS.REFUNDED ||
            orderInfo?.payStatus === ORDER_STATUS.APPROVAL_FAILED ||
            orderInfo?.payStatus === ORDER_STATUS.REFUND_FAILED
          ) && (
            <Box my={3}>
              <Divider className={classes.divider} />
            </Box>
          )}
          {fixedButtonWrapper(orderInfo?.payStatus)}
        </Box>
      </main>
    </Box>
  ) : (
    <Loading title={t('tips.empty_data', { field: '$t(glossary.order_info)' })} status={orderInfoStatus} />
  )
}

export default OrderInfo
